import { currencyToDefaultCountry } from '@kit/shared/currency';
import { getCountries } from 'react-phone-number-input';

export function resolvePhoneCountry(
  country?: string | null,
  currency?: string | null,
) {
  const normalized = country?.trim().toUpperCase();
  const code = normalized === 'UK' ? 'GB' : normalized;
  const countries = getCountries();

  return (
    countries.find((candidate) => candidate === code) ??
    countries.find(
      (candidate) => candidate === currencyToDefaultCountry(currency),
    ) ??
    'SA'
  );
}
